import superagent from '@ott/superagent';

import { REMOVE_CARD, REMOVE_CARD_SUCCESS, REMOVE_CARD_FAIL } from '../types';

export default function removeCard(id) {
  return function(dispatch) {
    dispatch({ id, type: REMOVE_CARD });

    superagent
      .get(`/_api/buyermanager/removeCard/?cardId=${id}`)
      .withCredentials()
      .then(res => {
        if (res && res.body && res.body.result === 'OK') {
          dispatch({ id, type: REMOVE_CARD_SUCCESS });
        } else {
          dispatch({ id, type: REMOVE_CARD_FAIL });
        }
      })
      .catch(() => {
        dispatch({ id, type: REMOVE_CARD_FAIL });
      });
  };
}
